module.exports = __webpack_public_path__ + "img/inventory_replenishment.b4067e6b.svg";